import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useCreateOutlookAuth } from '../services/react-query/integrations/outlook_calendar/useOutlookAuthCallback';
import { Loading } from '../uikit';

const OutlookOAuthCallback = () => {
  const location = useLocation();
  const { mutate: createOutlookAuth } = useCreateOutlookAuth();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const code = searchParams.get('code');
    if (code) {
      createOutlookAuth(code);
    }
  }, [location]);

  return <Loading />;
};

export default OutlookOAuthCallback;
